// eslint-disable-next-line
// @ts-ignore
import { getReactNativePersistence } from "./persistence";

import { PersistenceFactory } from "./index.d";

const factory: PersistenceFactory = getReactNativePersistence
export { factory as getReactNativePersistence };
